import isServer from '@anm/helpers/is/isServer';

const isMobile = (userAgent = !isServer() && window.navigator.userAgent) =>
  !!userAgent && /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/gi.test(userAgent);

export default isMobile;
